// extracted by mini-css-extract-plugin
module.exports = {"scale":"LayerStatisticsUtils_scale__11tZ9","cell":"LayerStatisticsUtils_cell__1Qydl"};